export const SHARE_HOLDING_GRAPH_COLORS = [
  "#FDD866",
  "#4A6784",
  "#82B1FF",
  "#F8AFC2",
  "#D19B6F",
];
